/**
 * Formats a number as currency with the appropriate symbol based on currency code
 * @param amount - The amount to format
 * @param currency - The currency code (defaults to ALL - Albanian Lek)
 * @returns Formatted currency string
 */
export function formatCurrency(
  amount: number | string,
  currency = 'ALL'
): string {
  const numAmount =
    typeof amount === 'string' ? Number.parseFloat(amount) : amount;

  switch (currency) {
    case 'USD':
      return `$${numAmount.toFixed(0)}`;
    case 'EUR':
      return `€${numAmount.toFixed(0)}`;
    case 'GBP':
      return `£${numAmount.toFixed(2)}`;
    case 'ALL':
    default:
      return `${numAmount.toFixed(0)} ALL`;
  }
}
